// extracted by mini-css-extract-plugin
export default {"form":"Form_form__eQ4ts","shimmer":"Form_shimmer__HJ2SR"};